/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerListMemberResponse } from "./MemberManagerListMemberResponse";

export type MemberManagerListMemberResponseApiRespoonse = {
  data?: MemberManagerListMemberResponse;
  status?: MemberManagerListMemberResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerListMemberResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
